import { APIContext } from "../../types";
import { makePath } from "../../../url";
import * as APITypesV2 from "../../generated-types/v2/Api";
import { getJSON } from "../../request";

export type SiteAPI = ReturnType<typeof createSiteAPI>;

export function createSiteAPI({ buildURL, fetchPagedJSON }: APIContext) {
  function querySites() {
    const path = makePath(["api", "v2", "site"]);
    const url = buildURL(path);

    const request = getJSON(url);

    return fetchPagedJSON<APITypesV2.Site>(request);
  }

  return {
    querySites,
  };
}
